import { n as e, o as t, s as n, u as r } from "./article-push.service-B2uLvzZS.js";
import { nextTick as i } from "vue";
//#region src/utils/constants.ts
var a = {
	kicker: "",
	headline: "",
	channel: [],
	brand: "",
	contentUuid: "",
	breakingNewsFlag: !1
}, o = { headline: "" }, s = [
	"bunte",
	"focus",
	"fitforfun",
	"finanzen100",
	"chip"
], c = ["chip"], l = {
	bunte: {
		kicker: {
			maxPerfectLength: 40,
			maxLength: 40
		},
		headline: {
			maxPerfectLength: 38,
			maxLength: 38
		}
	},
	focus: { headline: {
		maxPerfectLength: 80,
		maxLength: 100
	} },
	fitforfun: { headline: {
		maxPerfectLength: 80,
		maxLength: 100
	} },
	finanzen100: { headline: {
		maxPerfectLength: 80,
		maxLength: 100
	} },
	chip: { headline: {
		maxPerfectLength: 80,
		maxLength: 100
	} }
}, u = () => ({
	newsBanner: { ...o },
	contentWorkflow: null,
	requestedActivationDuration: void 0,
	isBannerDataLoading: !1,
	isBannerUpdating: !1,
	activeBannersWorkflows: []
}), d = (e) => e ? s.includes(e) : !1, f = async (t, n, i) => await (n ? r : e)({
	contentUuid: t,
	data: { newsBanner: { ...i } }
}), p = async (e, r) => {
	r.isBannerDataLoading = !0, r.requestedActivationDuration = void 0, r.contentWorkflow = null, r.activeBannersWorkflows = [];
	let i = e?.kicker ? `${e?.kicker} - ${e?.title}` : e?.title ?? "";
	if (r.newsBanner = {
		...o,
		headline: i
	}, !e?._id) {
		r.isBannerDataLoading = !1;
		return;
	}
	try {
		let [i, a] = await Promise.all([t(e._id), n(e.brand)]);
		i && (r.contentWorkflow = i), r.activeBannersWorkflows = [...a], i?.newsBanner && (r.newsBanner = { ...i.newsBanner });
	} finally {
		r.isBannerDataLoading = !1;
	}
}, m = async (e, t, r, a, s) => {
	await i(async () => {
		let i = await r?.validate(!0), c;
		if (!i || !t?.brand) {
			s.bannerFieldsAction();
			return;
		}
		try {
			if (a.isBannerUpdating = !0, c = (await s.onSaveAction?.(!1))?.contentUuid || t?._id, !c) {
				s.bannerFieldsAction();
				return;
			}
			let e = new Date(Date.now() + (a.requestedActivationDuration ?? 30) * 60 * 1e3), r = await f(c, !!a.contentWorkflow, {
				...a.newsBanner,
				showUntilDate: e
			});
			a.activeBannersWorkflows = [...await n(t.brand)], a.contentWorkflow = r, a.newsBanner = { ...r.newsBanner ? r.newsBanner : o };
		} finally {
			a.requestedActivationDuration = void 0, a.isBannerUpdating = !1, s.closeAction(), e === "publish" && c && s.onPushDoneAction?.(c);
		}
	});
}, h = async (e, t, r) => {
	await i(async () => {
		if (!e?._id || !t.contentWorkflow?.newsBanner) {
			r.bannerFieldsAction();
			return;
		}
		try {
			t.isBannerUpdating = !0;
			let r = await f(e._id, !!t.contentWorkflow, {
				...t.contentWorkflow.newsBanner,
				showUntilDate: /* @__PURE__ */ new Date()
			});
			t.activeBannersWorkflows = [...await n(e.brand)], t.newsBanner = { ...r.newsBanner ? r.newsBanner : o };
		} finally {
			t.isBannerUpdating = !1, r.closeAction();
		}
	});
};
//#endregion
export { h as a, l as c, m as i, s as l, p as n, d as o, u as r, c as s, f as t, a as u };

//# sourceMappingURL=utils-DVyOsAC8.js.map